import { Component } from '@angular/core';
import { StorageService } from '../../../core/storage/storageService';
import { ProfileFormDialog } from '../../../../../../../libs/Shared/components/profile-form/profile-form-dialog.component';
import { environment } from '../../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-profile-popup',
  standalone: false,
  templateUrl: './profile-popup-component.html',
  styleUrl: './profile-popup-component.css',
})
export class ProfilePopupComponent {

  public profileIsExpanded: boolean = false;
  public emailAddress: string = '';

  constructor(private storage: StorageService, private dialog: MatDialog) { 

    const currentUser = this.storage.getCurrentUser();
    if (currentUser) {
      this.emailAddress = currentUser.emailAddress;
    }

  }

  ngOnInit() {
    document.addEventListener('click', this.closeProfile.bind(this));
  }

  toggleProfile(event: Event | undefined) {
    this.profileIsExpanded = !this.profileIsExpanded;
    event?.stopPropagation();
  }

  openProfile() {
    this.dialog.open(ProfileFormDialog, {
      disableClose: true,
      data: { suiteUrl: environment.suiteUrl },
    });
  }

  closeProfile(event: Event | undefined) {
    if (event && (event.target === document.getElementById('profile-container') || event.target === document.getElementById('profile-link'))) {
      return;
    }
    this.profileIsExpanded = false;
  }

}
